export function validateEmail(email: string): boolean {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}

export function modifyEmailWithUserId(email: string, userId: string): string {
  if (!email || !userId) {
    throw new Error('Email and userId are required');
  }

  // Validate email format
  const emailRegex = /^([^@]+)@(.+)$/;
  const match = email.match(emailRegex);
  if (!match) {
    throw new Error('Invalid email format');
  }

  // Get last 4 characters of userId
  const lastFourDigits = userId.slice(-4);
  if (!/^\w{4}$/.test(lastFourDigits)) {
    throw new Error('Invalid userId format');
  }

  const [_, localPart, domain] = match;
  return `${localPart}+${lastFourDigits}@${domain}`;
}

export function extractOriginalEmail(modifiedEmail: string): string {
  const emailRegex = /^([^+]+)(?:\+\w{4})?@(.+)$/;
  const match = modifiedEmail.match(emailRegex);
  if (!match) {
    throw new Error('Invalid email format');
  }
  return `${match[1]}@${match[2]}`;
}